import { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { FEATURES } from 'src/constants/features';

import useAuth from '../hooks/useAuth';

export function NotAuthGuard({ authRedirectPath = '/app/my-dashboard', children }) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: authRedirectPath,
        }}
      />
    );
  }

  return children;
}

NotAuthGuard.propTypes = {
  authRedirectPath: PropTypes.string,
  children: PropTypes.node,
};

export function AuthGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: location.pathname },
        }}
      />
    );
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export function FeatureGuard({ feature, children }) {
  const { isFeatureActive } = useAuth();
  const [status, setStatus] = useState({ isViewable: false, loaded: false });

  useEffect(() => {
    let cancelled = false;

    const loadFeatureStatus = async () => {
      const featureInfo = await isFeatureActive(feature);

      if (cancelled) {
        return;
      }

      setStatus({
        isViewable: !!featureInfo?.isViewable,
        loaded: true,
      });
    };

    loadFeatureStatus();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feature]);

  if (status.loaded && !status.isViewable) {
    return (
      <Redirect
        to={{
          pathname: '/404',
        }}
      />
    );
  }

  return children;
}

FeatureGuard.propTypes = {
  feature: PropTypes.oneOf(FEATURES),
  children: PropTypes.node,
};
